import Blockly from "blockly";
import Schema from "../schema";

export const menu = {
  'set_stat': {
    name: (<div className="text"><u>S</u>et player stat</div>),
    trigger: 's',
  },
  'modify_stat': {
    name: (<div className="text"><u>M</u>odify player stat</div>),
    trigger: 'm',
  },
  'player_teleport': {
    name: (<div className="text"><u>T</u>eleport player</div>),
    trigger: 't',
  },
  'player_transform': {
    name: (<div className="text">T<u>r</u>ansform player</div>),
    trigger: 'r',
  },
  'friend': {
    name: (<div className="text">Spawn a <u>F</u>riend</div>),
    trigger: 'f',
  },
  'player_poopspell': {
    name: (<div className="text">Use a <u>P</u>oop Spell</div>),
    trigger: 'p',
  },
  'player_damage_cooldown': {
    name: (<div className="text">Set <u>I</u>nvincibility Frames</div>),
    trigger: 'i',
  },
}

/* ****************************************************************************************************************
 * Set Stats
 ******************************************************************************************************************/
Blockly.Blocks['set_stat'] = {
  init: function () {
    let shadow = this.workspace.newBlock('data_stats');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['stat'])
      .appendField('Set')
      .connection
      .connect(shadow.outputConnection);
    this.setInputsInline(false);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Sets the specified stat to the specified value.');
  }
}

Blockly.JSON['set_stat'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    return {
      action: 'player_stat',
      params
    }
  } else return;
}

/* ****************************************************************************************************************
 * Modify Stats
 ******************************************************************************************************************/
Blockly.Blocks['modify_stat'] = {
  init: function () {
    this.appendDummyInput('stat')
      .appendField('Modify')
      .appendField(
        new Blockly.FieldDropdown([
          ['Random', 'random'],
          ['Damage', 'damage'],
          ['Fire', 'fire'],
          ['Luck', 'luck'],
          ['Range', 'range'],
          ['Shot', 'shot'],
          ['Speed', 'speed'],
        ]),
        'Stat'
      )
      .appendField('by')
      .appendField(
        new Blockly.FieldDropdown([
          ['increasing', 'increasing'],
          ['decreasing', 'decreasing'],
        ]),
        'Modifier'
      )
      .appendField('by')
      .appendField(
        new Blockly.FieldTextInput(
          '1',
          this.validateStat
        ),
        'Value'
      );
    this.setInputsInline(false);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Modify the specified stat by the specified modifier and value.');
    this.setHelpUrl('');
  },
  validateStat: function (value) {
    let num = parseFloat(value);
    if (!num) return null;
    if (num < 0) return null;
    if (num > 420.69) return null;
  }
};

Blockly.JSON['modify_stat'] = (block) => {
  let stat = block.getFieldValue('Stat');
  let modifier = block.getFieldValue('Modifier');
  let value = block.getFieldValue('Value');

  return {
    action: 'player_stat',
    params: {
      stat,
      modifier,
      value: parseInt(value, 10),
    }
  };
};

Schema.registerAction('player_stat', {
  "if": {
    "properties": {
      "action": {
        "const": "player_stat"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "stat": {
            "enum": [
              "damage",
              "fire",
              "luck",
              "range",
              "shot",
              "speed",
              "random",
            ]
          },
          "modifier": {
            "enum": [
              "increasing",
              "decreasing",
            ],
          },
          "value": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
          "from_param2": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "stat",
              "value",
            ],
          },
          {
            "required": [
              "from_param",
              "from_param2"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ]
  }
});
/* ****************************************************************************************************************
 * Teleport
 ******************************************************************************************************************/
Blockly.Blocks['player_teleport'] = {
  init: function () {
    let shadow = this.workspace.newBlock('data_rooms');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['room'])
      .appendField('Teleport player to')
      .connection
      .connect(shadow.outputConnection);
    this.setInputsInline(false);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Teleport the player to the specified room, if that room exists on the current floor.');
  }
};

Blockly.JSON['player_teleport'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);

  if (params) {
    return {
      action: 'player_teleport',
      params
    }
  } else return;
};

Schema.registerAction('player_teleport', {
  "if": {
    "properties": {
      "action": {
        "const": "player_teleport"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "type": {
            "enum": [
              "room",
            ]
          },
          "entity_id": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "type",
              "entity_id"
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ]
  }
});

/* ****************************************************************************************************************
 * Transform
 ******************************************************************************************************************/
Blockly.Blocks['player_transform'] = {
  init: function () {
    let shadow = this.workspace.newBlock('data_characters');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['character'])
      .appendField('Transform player to')
      .connection
      .connect(shadow.outputConnection);
    this.setInputsInline(false);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Transform player in to the specified character.');
    this.setHelpUrl('');
  }
};

Blockly.JSON['player_transform'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    return {
      action: 'player_transform',
      params
    }
  } else return;
};

Schema.registerAction('player_transform', {
  "if": {
    "properties": {
      "action": {
        "const": "player_transform"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "type": {
            "enum": [
              "character",
            ]
          },
          "entity_id": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "type",
              "entity_id"
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ]
  }
});

/* ****************************************************************************************************************
 * Spawn a friend for Isaac
 ******************************************************************************************************************/
Blockly.Blocks['friend'] = {
  init: function () {
    let shadow = this.workspace.newBlock('default_friend');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck([
        'enemy',
      ])
      .appendField('Spawn friendly')
      .connection
      .connect(shadow.outputConnection);
    this.setInputsInline(false);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Spawns the specified enemy as a friend for Isaac that persists until it dies.');
  },
  onchange: function () {
    const connection = this.getInput('Input').connection.targetConnection;
    if (connection) {
      this.setEnabled(true);
    } else {
      this.setEnabled(false);
    }
  }
}

Blockly.JSON['friend'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);

  if (params) {
    return {
      action: 'friend',
      params
    }
  } else return;
}

Blockly.Blocks['default_friend'] = {
  init: function () {
    this.appendDummyInput('Input')
      .appendField('Random spawnable enemy.')
    this.setOutput(true, ['enemy'])
  }
}

Blockly.JSON['default_friend'] = (block) => {
  return {
    type: 'random',
    entity_id: -1
  }
}

Schema.registerAction('friend', {
  "if": {
    "properties": {
      "action": {
        "const": "friend"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "entity_id": {
            "type": "number"
          },
          "type": {
            "enum": [
              "enemy",
              "monster",
              "boss"
            ]
          },
          "from_param": {
            "type": "string",
            "minLength": 1,
          },
          "entity": {
            "properties": {
              "id": {
                "type": "number",
              },
              "subtype": {
                "type": "number",
              },
              "variant": {
                "type": "number",
              }
            },
            "additionalProperties": false,
          },
        },
        "oneOf": [
          {
            "required": [
              "entity_id"
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
          {
            "required": [
              "entity"
            ],
          }
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params",
    ]
  }
});

/* ****************************************************************************************************************
 * Use a Poop Spell
 ******************************************************************************************************************/
Blockly.Blocks['player_poopspell'] = {
  init: function () {
    let shadow = this.workspace.newBlock('data_poopspells');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['poopspell'])
      .appendField('Use the specified Poop Spell')
      .connection
      .connect(shadow.outputConnection);
    this.setInputsInline(false);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Casts a Poop Spell (from Tainted Blue Baby).');
    this.setHelpUrl('');
  }
};

Blockly.JSON['player_poopspell'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    return {
      action: 'player_poopspell',
      params
    }
  } else return;
};

Schema.registerAction('player_poopspell', {
  "if": {
    "properties": {
      "action": {
        "const": "player_poopspell"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "type": {
            "enum": [
              "spell",
            ]
          },
          "spell_id": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "type",
              "spell_id",
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ]
  }
});

/* ****************************************************************************************************************
 * Set the players damage cooldown (aka invincibility frames) for x seconds
 ******************************************************************************************************************/
Blockly.Blocks['player_damage_cooldown'] = {
  init: function () {
    let shadow = this.workspace.newBlock('input_number');
    shadow.setShadow(true);
    shadow.initSvg();
    shadow.render();

    this.appendValueInput('Input')
      .setCheck(['number'])
      .appendField('Turn on invincibility frames for')
      .connection
      .connect(shadow.outputConnection)
    this.appendDummyInput('trailing')
      .appendField('seconds');

    this.setInputsInline(true);
    this.setPreviousStatement(true);
    this.setNextStatement(true);
    this.setColour('#606060');
    this.setTooltip('Turn on invincibility frames for the player for the specified amount of seconds.');
    this.showHelp = window.ShowEditorHelp(this, 'test', <div>This is a test with <u>some</u> <i>inline</i> markup!</div>);
  }
};

Blockly.JSON['player_damage_cooldown'] = (block) => {
  let params = Blockly.JSON.valueToCode(block, 'Input', Blockly.JSON.ORDER_ATOMIC);
  if (params) {
    if (params.hasOwnProperty('value')) {
      params['duration'] = params['value'];
      delete params.value
    }

    return {
      action: 'player_damage_cooldown',
      params
    }
  } else return;
};

Schema.registerAction('player_damage_cooldown', {
  "if": {
    "properties": {
      "action": {
        "const": "player_damage_cooldown"
      }
    }
  },
  "then": {
    "properties": {
      "params": {
        "properties": {
          "duration": {
            "type": "number",
          },
          "from_param": {
            "type": "string",
          },
        },
        "oneOf": [
          {
            "required": [
              "duration",
            ],
          },
          {
            "required": [
              "from_param"
            ],
          },
        ],
        "additionalProperties": false
      }
    },
    "required": [
      "params"
    ],
  }
});

